/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import ProfileIntakePage from '../profileIntakePage/ProfileIntakePage';
import appColors from '../../../../common/app_colors';

const { wholeMeAssets } = appColors;

const TimerSplashIntakePage = ({
  nextOnClick,
  backgroundColor,
  backgroundOverlay,
  pushTimer,
  paginationMeta,
  title,
  subtitle,
  subtitle2,
  loadingText,
  editText,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    if (pushTimer) {
      const timer = setTimeout(() => {
        setIsLoading(false);
        nextOnClick();
      }, pushTimer);

      return () => clearTimeout(timer);
    }
    return undefined;
  }, []);

  const titleStyleOverride = {
    headerStyles: {
      fontSize: '50px',
      fontWeight: 'bold',
      color: wholeMeAssets.splashTitle,
    },

    subHeaderStyles: {
      paddingTop: '50px',
      fontSize: '34px',
      fontWeight: '900',
      lineHeight: '1.3',
      textAlign: 'left',
      color: 'white',
    },

  };

  const childrenOverrideStyles = {
    fontSize: '30px',
    fontWeight: 'bold',
    height: '200px',
  };

  return (
    <ProfileIntakePage
      variant="splash"
      editText={editText}
      hideChildren
      title={title}
      subtitle={subtitle}
      subtitle2={subtitle2}
      loadingText={loadingText}
      titleStyleOverride={titleStyleOverride}
      childrenOverrideStyles={childrenOverrideStyles}
      backgroundColor={backgroundColor || wholeMeAssets.splashBackground}
      backgroundOverlay={backgroundOverlay}
      paginationMeta={paginationMeta}
      isLoading={isLoading}
    />
  );
};

export default TimerSplashIntakePage;
